// extracted by mini-css-extract-plugin
export default {"icon":"ChromeBar-module_icon_d7920fad","browserBtn":"ChromeBar-module_browserBtn_ae00461b","browserBtnIcon":"ChromeBar-module_browserBtnIcon_f6c12788"};